import { Box, Button, Typography } from "@mui/material"
import { signIn } from "next-auth/react"
import { useState } from "react"
import Image from "next/image"
import { useTranslation } from "@/contexts/LanguageContext"

const SignInPage = () => {
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  const handleLogin = async () => {
    setLoading(true)
    await signIn("google")
    setLoading(false)
  }

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f8f8f8",
        overflow: "hidden"
      }}>
      {/* Layer 1: Colorful animated gradient */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(120deg,rgb(255, 232, 232),rgb(222, 246, 246),rgb(236, 216, 247))",
          backgroundSize: "600% 600%",
          animation: "gradientMove 10s ease infinite",
          zIndex: 0
        }}
      />

      {/* Login Box */}
      <Box
        sx={{
          position: "relative",
          backgroundColor: "rgba(255, 255, 255, 1)",
          padding: 4,
          borderRadius: "5px",
          boxShadow: "0px 8px 20px rgba(0,0,0,0.25)",
          maxWidth: 400,
          width: "90%",
          textAlign: "center",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255,255,255,0.4)",
          zIndex: 2
        }}>
        <Image
          src="/media/images/odynxLogo.png"
          alt={t("auth.signIn.logoAlt")}
          width={150}
          height={40}
          style={{ marginBottom: "1rem" }}
          priority
        />
        <Typography variant="body1" sx={{ mb: 4, color: "gray" }}>
          {t("auth.signIn.tagline")}
        </Typography>
        <Button
          onClick={handleLogin}
          variant="contained"
          sx={{
            color: "#FFF",
            width: "50%",
            padding: "0.5rem",
            borderRadius: "5px",
            backgroundColor: "#001F54",
            transition: "all 0.3s ease",
            "&:hover": { backgroundColor: "#003DA5" }
          }}
          disabled={loading}>
          {loading ? t("auth.signIn.loadingCta") : t("auth.signIn.cta")}
        </Button>
      </Box>

      {/* Global Styles */}
      <style jsx global>{`
        @keyframes gradientMove {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
      `}</style>
    </Box>
  )
}

export default SignInPage
